import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import {
    FormControl,
    TextField,
    Select,
    MenuItem,
    Grid,
    Button,
    Container,
    Icon
} from '@mui/material';
import { Clear } from '@material-ui/icons';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { incidentStatus } from '../../constants/constants.json';
import useStyles from './styles';
import { saveIncident } from '../../redux/Actions/incident.action';

export default function Create(props) {
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const incidentToEdit = props.location.state;
    const getInstance = useSelector((state) => state.clientReducer);
    const [instanceName, setInstanceName] = useState('');
    const [title, setTitle] = useState(incidentToEdit?.title || '');
    const [reason, setReason] = useState(incidentToEdit?.reason || '');
    const [status, setStatus] = useState(incidentToEdit?.status || 'New');
    function getStatus(service) {
        return incidentToEdit?.servicesAffected?.filter((i) => i.service === service)[0]?.status;
    }
    const [crawlerStatus, setCrawlerStatus] = useState(getStatus('Crawler') || 'Operational');
    const [analyticsStatus, setAnalyticsStatus] = useState(
        getStatus('Analytics API') || 'Operational'
    );
    const [adminStatus, setAdminStatus] = useState(getStatus('Admin Panel') || 'Operational');
    const [searchStatus, setSearchStatus] = useState(getStatus('Search API') || 'Operational');
    const [helpCentreStatus, setHelpStatus] = useState(getStatus('Help Centre') || 'Operational');
    const [searchClientStatus, setSCStatus] = useState(getStatus('Search Client') || 'Operational');
    const [checked, setChecked] = useState(false);
    const [tenantId, setTenantId] = useState(
        Cookies.get('tenantId') ? Cookies.get('tenantId') : ''
    );
    const services = [
        {
            service: 'Crawler',
            status: crawlerStatus,
            func: setCrawlerStatus
        },
        {
            service: 'Analytics API',
            status: analyticsStatus,
            func: setAnalyticsStatus
        },
        {
            service: 'Admin Panel',
            status: adminStatus,
            func: setAdminStatus
        },
        {
            service: 'Search API',
            status: searchStatus,
            func: setSearchStatus
        },
        {
            service: 'Help Centre',
            status: helpCentreStatus,
            func: setHelpStatus
        },
        {
            service: 'Search Client',
            status: searchClientStatus,
            func: setSCStatus
        }
    ];
    const serviceStatus = ['Operational', 'Performance Degraded', 'Partial Outage', 'Major Outage'];
    const [titleReqd, setTitleReqd] = useState(false);
    const [reasonReqd, setReasonReqd] = useState(false);
    const titleRef = useRef();
    const reasonRef = useRef();
    const validate = () => {
        let check = false;
        if (reason === '') {
            setReasonReqd(true);
            check = true;
            window.scrollTo(0, reasonRef.current.offsetTop);
        }
        if (title === '') {
            setTitleReqd(true);
            check = true;
            window.scrollTo(0, titleRef.current.offsetTop);
        }
        return check;
    };

    const handleServiceChange = (service, event) => {
        service.service.func(event.target.value);
    };

    const submitIncident = (event) => {
        event.preventDefault();
        if (!validate()) {
            dispatch(
                saveIncident({
                    _id: props.location?.state?._id, // in case of editing existing incident
                    id: props.location?.state?.id, // in case of editing existing incident
                    tenantId,
                    title,
                    reason,
                    reportedAt: props.location?.state?.reportedAt || new Date().getTime(),
                    status,
                    checked,
                    servicesAffected: services.filter((s) => s.status !== 'Operational')
                })
            );
            if (props.location?.state) toast.success('Instance updated successfully');
            else toast.success('Instance created successfully');
            props.history.push('/app/incidents/list');
        }
    };

    useEffect(() => {
        setInstanceName(getInstance.clientInfo.name);
        setTenantId(getInstance.clientInfo.tenantId);
    }, [getInstance.clientInfo.name, getInstance.clientInfo.tenantId]);
    return (
        <>
            <Container fixed className={classes.incidentContainer}>
                {/* <Box sx={{ bgcolor: '#cfe8fc', height: '100vh' }} /> */}
                <p className={classes.pageTitle}>
                    Add new Incident
                    <Icon to="/app/incidents/list" component={Link}>
                        <Clear />
                    </Icon>
                </p>
                <form onSubmit={submitIncident} className={classes.incidentCreateForm}>
                    <FormControl fullWidth>
                        <span className={classes.fieldLabels}>Instance</span>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={classes.inputFields}
                            disabled
                            value={instanceName}
                            InputLabelProps={{ style: { fontSize: '13px' } }}
                        />
                        <span className={classes.fieldLabels}>Title*</span>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            onFocus={() => setTitleReqd(false)}
                            error={titleReqd}
                            helperText={titleReqd && 'Required field'}
                            className={classes.inputFields}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            InputLabelProps={{ style: { fontSize: '13px' } }}
                            ref={titleRef}
                        />
                        <span className={classes.fieldLabels}>Reason*</span>
                        <TextField
                            id="outlined-multiline-static"
                            multiline
                            onFocus={() => setReasonReqd(false)}
                            error={reasonReqd}
                            helperText={reasonReqd && 'Required field'}
                            rows={4}
                            className={classes.inputFieldDescription}
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            InputLabelProps={{ style: { fontSize: '13px' } }}
                            ref={reasonRef}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <span className={classes.fieldLabels}>Status</span>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select1"
                            value={status}
                            onChange={(event) => setStatus(event.target.value)}
                            className={classes.inputSelect}
                        >
                            {incidentStatus.map((status, index) => (
                                <MenuItem value={status} key={index}>
                                    {status}
                                </MenuItem>
                            ))}
                        </Select>
                        <div>
                            <div className={classes.servicesInput}>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <span className={classes.fieldLabels}>
                                            Services Affected
                                        </span>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <span className={classes.fieldLabels}>
                                            Status of services
                                        </span>
                                    </Grid>
                                    {services.map((service, index) => (
                                        <FormControl
                                            key={index}
                                            fullWidth
                                            className={classes.serviceStatus}
                                        >
                                            <Grid item xs={4}>
                                                <TextField
                                                    id="outlined-basic2"
                                                    variant="outlined"
                                                    value={service.service}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item xs={8} className={classes.changeTopPadding}>
                                                <Select
                                                    labelId="demo-simple-select-label2"
                                                    id="demo-simple-select2"
                                                    onChange={(e) =>
                                                        handleServiceChange({ service }, e)
                                                    }
                                                    fullWidth
                                                    className={classes.inputSelect}
                                                    value={service.status}
                                                    name={service.label}
                                                >
                                                    {serviceStatus.map((status, index) => (
                                                        <MenuItem value={status} key={index}>
                                                            {status}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                        </FormControl>
                                    ))}
                                </Grid>
                                <div className={classes.notification}>
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => setChecked(!checked)}
                                        style={{
                                            height: '13px',
                                            width: '18px'
                                        }}
                                    />
                                    Send Notification to subscribers.
                                    <span className={classes.reqdText}>
                                        (*)All fields are required
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className={classes.createButtons}>
                            <Button
                                variant="outlined"
                                to="/app/incidents/list"
                                className={classes.noTransform}
                                component={Link}
                            >
                                Cancel
                            </Button>
                            <Button variant="outlined" type="Submit">
                                {props.location?.state ? 'Save Incident' : 'Create Incident'}
                            </Button>
                        </div>
                    </FormControl>
                </form>
            </Container>
        </>
    );
}
